var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("scenario-list-item-base", {
    class: { "deactivated-batch": _vm.isCancelled },
    attrs: { scenario: _vm.scenarioBatch },
    scopedSlots: _vm._u([
      {
        key: "bottom",
        fn: function() {
          return [
            _c("scenario-deactivation-confirmation-popup", {
              ref: "deactivationPopup",
              attrs: { scenario: _vm.scenarioBatch },
              on: { confirm: _vm.deactivate }
            }),
            _vm._v(" "),
            _c("scenario-activation-confirmation-popup", {
              ref: "activationPopup",
              attrs: { scenario: _vm.scenarioBatch },
              on: { confirm: _vm.activate }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "scenario-list-item-content" }, [
              _c("div", [
                _c("div", { staticClass: "row form-group" }, [
                  _c("div", { staticClass: "col-3" }, [
                    _c("span", { staticClass: "dmv-text dmv-text-secondary" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.resource(
                              "DmvScenarioActiveBatchListModel_EstimatedCosts_Label"
                            )
                          ) +
                          ":\n                    "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col" }, [
                    _c("span", { staticClass: "dmv-text dmv-text-secondary" }, [
                      _vm._v("€ " + _vm._s(_vm.estimatedCosts) + ",-")
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row form-group" }, [
                  _c("div", { staticClass: "col-3" }, [
                    _c("span", { staticClass: "dmv-text dmv-text-secondary" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.resource(
                              "DmvScenarioActiveBatchListModel_EstimatedRecipients_Label"
                            )
                          ) +
                          ":\n                    "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-9" }, [
                    _c(
                      "span",
                      {
                        staticClass:
                          "dmv-text dmv-text-important estimate-costs"
                      },
                      [_vm._v(_vm._s(_vm.estimatedRecipients))]
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _vm.canEdit
              ? _c(
                  "div",
                  {
                    staticClass: "scenario-list-item-content edit-btn-container"
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "pull-right dmv-text dmv-text-secondary mdb-icon-btn edit",
                        on: { click: _vm.edit }
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-pencil fa-2x",
                          attrs: { "aria-hidden": "true" }
                        })
                      ]
                    )
                  ]
                )
              : _vm._e()
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }